import { transformSearch } from "@/api/helper.ts";
import caseStageService from "@/features/case-record/api/services/case-stage-service.ts";
import type { CaseRecord } from "@/features/case-record/types/case-records.ts";
import { queryOptions } from "@tanstack/react-query";
import { z } from "zod";

export const caseSearchQuery = z.object({
	search: z.string().optional(),
	status: z.string(),
	case_classification: z.string().nullable().optional(),
	per_page: z.number().optional(),
	page: z.number().nullable().optional(),
});

export const caseStagesQueryOptions = (search?: z.infer<typeof caseSearchQuery>, options?: { enabled: boolean }) => {
	return queryOptions({
		queryKey: ["case_classification", "case_stages", search],
		queryFn: () => caseStageService.list(transformSearch(search, ["status", "search", "case_classification"])),
		...options,
	});
};
export const caseRespondentsQueryOptions = (id: CaseRecord["id"]) => {
	return queryOptions({
		queryKey: ["respondents"],
		queryFn: () => caseStageService.listRespondents(id),
	});
};
